import React, { useEffect } from 'react';
import { Modal } from 'react-bootstrap';

interface ModalTemporarioProps {
  show: boolean;
  message: string[];
  onHide?: () => void;
  tempoEmSegundos?: number;
}

function ModalAlertaTemporario({ show, message, onHide, tempoEmSegundos = 5 }: ModalTemporarioProps) {
  useEffect(() => {
    if (show && tempoEmSegundos) {
      const timer = setTimeout(() => {
        if (onHide) {
          onHide();
        }
      }, tempoEmSegundos * 1000);
      return () => clearTimeout(timer);
    }
  }, [show, onHide, tempoEmSegundos]);

  return (
    <Modal show={show} onHide={onHide} backdrop="static">
      <Modal.Header>
        <Modal.Title>Atenção</Modal.Title>
        <button type='button' className='btn-close' aria-label='Close' onClick={onHide} />
      </Modal.Header>
      <Modal.Body role='alert'>
        {message.map((item, index) => (
          <div key={index}>{item}</div>
        ))}
      </Modal.Body>
    </Modal>
  );
}

export default ModalAlertaTemporario;
